import * as GridLayout from '@/components/GridLayout/GridLayout'
import { type InsurableLimitFragment } from '@/services/graphql/generated'
import { Badge } from 'ui/src/components/Badge/Badge'
import { Text } from 'ui/src/components/Text/Text'
import { badge, grid } from './InsurableLimits.css'

type InsurableLimitsProps = {
  items: Array<InsurableLimitFragment>
}

const getColumns = (items: Array<InsurableLimitFragment>) => {
  const noOfItems = items.length
  if (noOfItems > 4 || noOfItems === 3) return '1/3'
  return '1/2'
}

export function InsurableLimits({ items }: InsurableLimitsProps) {
  const columns = getColumns(items)

  return (
    <GridLayout.Root className={grid}>
      {items.map((item) => (
        <GridLayout.Content width={columns} align="left" key={item.label}>
          <Badge className={badge} as="h3">
            {item.label}
          </Badge>
          <Text size="xl">{item.limit}</Text>
          <Text size="xl" color="textSecondary" balance={true}>
            {item.description}
          </Text>
        </GridLayout.Content>
      ))}
    </GridLayout.Root>
  )
}
